import React, { useState } from 'react';
import '../css/Content.css'
import { IoIosArrowDown } from "react-icons/io";

const SectionFaq = ({ data }) => {
    const [selectedQuestion, setSelectedQuestion] = useState(null);
    const toggleQuestion = (index) => {
        setSelectedQuestion(selectedQuestion === index ? null : index);
    };

    return (
        <div className="faq-container">
            <h2 className='large'>Perguntas Frequentes</h2>
            {data.map((item, index) => (
                <div key={index} className="faq-item subtitle">
                    <div className={`question ${selectedQuestion === index ? 'active' : ''}`} onClick={() => toggleQuestion(index)}>
                        <div>{item.question}</div> <div><IoIosArrowDown /></div>
                    </div>
                    <div className={`answer-container ${selectedQuestion === index ? 'visible' : ''}`}>
                        <div className="answer">
                            {item.answer}
                        </div>
                    </div>
                </div>
            ))}
        </div>

    );
};

export default SectionFaq;
